import styled from 'styled-components'

export const Body = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  height: '57.8rem',
  width: '47rem',
}))

export const TabContent = styled.div(() => ({
  minHeight: '40rem',
}))
